
<template>
    <div class="pekerjaan__pekerjaan-item sm:px-4 px-2 py-2" :class="{'pekerjaan__opened-pekerjaan': !pekerjaan.unread}">

        <!-- PEKERJAAN ROW 1 : META -->
        <div class="flex w-full">

            <div class="flex items-center mr-4">
                <vs-checkbox v-model="isSelectedPekerjaan" @click.stop class="vs-checkbox-small ml-0 mr-1"></vs-checkbox>
            </div>

            <div class="flex w-full justify-between items-start" v-on:click="openSide(pekerjaan)">
              <vs-row>
                <vs-col vs-align="left" class="pr-2" vs-w="9">
                  <div class="pekerjaan__details">
                      <div class="flex justify-between">
                        <div>
                          <span>{{ pekerjaan.ahsp.pekerjaan_sub_nama }}</span>
                          <vs-chip style="" transparent class="mr-2" :color="penangananColor(pekerjaan.penanganan)">{{pekerjaan.penanganan }}</vs-chip>
                        </div>
                        <div class="pekerjaan__labels hidden sm:flex items-center">
                          <vs-chip :color="labelColor(label)" v-for="(label, index) in pekerjaan.labels" :key="index" class="ml-2" style="min-height:10px;min-width:10px;"></vs-chip>
                        </div>
                      </div>
                      <h6>
                        {{pekerjaan.ahsp.kode}} {{ pekerjaan.task_title }} - {{ Number(pekerjaan.task_quantity).toLocaleString() }} {{ pekerjaan.ahsp.nama_satuan }}
                      </h6>
                      <div>
                        <span>Urutan - {{ pekerjaan.urutan }} / </span>
                        <span>Mulai Hari Ke - {{ pekerjaan.mulai }} / </span>
                        <span>Durasi - {{ pekerjaan.hari }} Hari</span>
                      </div>
                    
                  </div>
                </vs-col>

                <vs-col vs-align="right" class="text-right" vs-w="3">
                  <div class="pekerjaan-item__meta mt-2">
                    <h6>{{ pekerjaan.task_quantity * pekerjaan.ahsp.task_total | currency }}</h6>
                  </div>
                </vs-col>
              </vs-row>
            </div>
        </div>
        <!-- /PEKERJAAN ROW 1 -->
    </div>
</template>

<script>
export default {
  props: {
    pekerjaan: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isSelectedPekerjaan: this.isSelected
    }
  },
  watch: {
    isSelected (value) {
      this.isSelectedPekerjaan = value
    },
    isSelectedPekerjaan (val) {
      val ? this.$emit('addToSelected', this.pekerjaan.id) : this.$emit('removeSelected', this.pekerjaan.id)
    }
  },
  computed: {
    labelColor () {
      return (label) => {
        const tags = this.$store.state.pekerjaan.pekerjaanTags
        return tags.find((tag) => {
          return tag.name === label
        }).color
      }
    }
  },
  methods: {
    toggleIsStarred () {
      const payload = { pekerjaanId: this.pekerjaan.id, value: !this.pekerjaan.isStarred }
      this.$store.dispatch('pekerjaan/toggleIsPekerjaanStarred', payload)
    },
    openSide (pekerjaan) {
      this.$emit('updateOpenPekerjaan', pekerjaan)
    },
    penangananColor (p) {
      if (p === 'utama') {
        return 'primary'
      } else {
        return 'warning'
      }
    },
    penangananText (p) {
      if (p === 'utama') {
        return 'primary'
      } else {
        return 'warning'
      }
    },
  }
}

</script>


<style lang="scss" scoped>
.timeline-icon {
    position: absolute;
    top: 0;
    left: -4.3rem;
    border-radius: 50%;
    padding: .75rem;
    padding-bottom: 0.4rem;
}
</style>